import axiosInstance from "../Config/axiosConfig";

const getHeaders = () => {
  const accessToken = localStorage.getItem("accessToken");
  const storedDeviceId = localStorage.getItem("deviceId");
  const storedUserIp = localStorage.getItem("userIp");

  return {
    Authorization: `Bearer ${accessToken}`,
    ...(storedDeviceId && { UserDevice: storedDeviceId }),
    ...(storedUserIp && { UserIPAddress: storedUserIp }),
    "Content-Type": "application/json",
  };
};

export const fetchSubjects = async () => {
  try {
    const response = await axiosInstance.get("/Admin/get-subjects", {
      headers: getHeaders(),
    });
    console.log("check subject having education level ID", response.data)
    let subjectsData = [];
    if (Array.isArray(response.data)) {
      subjectsData = response.data;
    } else if (
      response.data &&
      Array.isArray(response.data.subjects)
    ) {
      subjectsData = response.data.subjects;
    } else if (response.data && response.data.data) {
      subjectsData = Array.isArray(response.data.data)
        ? response.data.data
        : [response.data.data];
    } else {
      subjectsData = [response.data];
    }

    return subjectsData;
  } catch (error) {
    console.error("Error fetching subjects:", error);
    throw error;
  }
};

export const createSubject = async (subjectData) => {
  try {
    const response = await axiosInstance.post(
      "/Subject/create",
      subjectData,
      {
        headers: getHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating subject:", error);
    throw error;
  }
};

// ⭐ NEW – Delete Subject Endpoint
export const deleteSubject = async (subjectId) => {
  try {
    const response = await axiosInstance.get(
      `/Subject/delete/${subjectId}`,
      {
        headers: getHeaders(),
      }
    );
    console.log('subject deleted', response.data)
    return response.data;
  } catch (error) {
    console.error("Error deleting subject:", error);
    throw error;
  }
};
